import { createAction, props } from '@ngrx/store';
export const maintainSearchInput = createAction('[SearchSectionComponent] MaintainSearchInput', props<{ searchStr: string }>());
export const maintainFilterType = createAction('[SearchSectionComponent] MaintainFilterType', props<{ filterBy: string }>());
export const reset = createAction('[SearchSectionComponent] Reset');

